// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1iFrV","author":"Table_author__3KGTi","authorImage":"Table_authorImage__1lFsP","unreadRow":"Table_unreadRow__3msIP"};